module.exports = __webpack_public_path__ + "static/media/preguntas.b0b4acfc.svg";